(ns app.front.view.search.complaint.search-mode
  (:require [app.domain.complaint.model :as complaint-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui.updated :as ui-updated]
            [app.front.util :as futil]
            [app.front.view.complaint.add-form :as complaint-form]
            [app.front.view.complaint.dashboard :as complaint-dashboard]
            [app.front.view.complaint.detail-view :as complaint-detail-view]
            [app.front.view.complaint.new-case-view :as new-case-view]
            [app.front.view.complaint.subs :as complaint-subs]
            [app.front.view.map-common.info-box :as map-common-info-box]
            [app.front.view.public-records.ui :as public-records-ui]
            [app.front.view.search.complaint.subs :as complaint-search-subs]
            [app.front.view.search.list-view :as list-view]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]))

(defn result-address [{property-address  :property/address
                       complaint-address :complaint/address
                       :keys             [location]}]
  (or property-address
      complaint-address
      (some->> location
               :coordinates
               reverse
               (map #(futil/to-fixed % 5))
               (str/join ", "))))

(defn cluster-results [results]
  (group-by result-address results))

(defn permit-type-name [{:complaint/keys [permit-type-names] :keys [permit-type]} tr lang]
  (or (i18n-model/get-text-from-entities-or-map permit-type-names lang)
      (some-> permit-type vector tr)))

(defn render-clustered-results [address+results open-result-view tr lang]
  (futil/for-frag [[address results] address+results]
    [:div.mb-3
     [:h4.uppercase.text-sm address]
     (futil/for-frag [{:complaint/keys [category-names] :domain/keys [state] :as result} results]
       [:button.p-3.bg-white.mt-2.w-full.border-0.text-left.select-search-result-button
        {:on-click #(open-result-view result)}
        [:div.font-bold (i18n-model/get-text-from-entities-or-map category-names lang)]
        [:div.mt-1 (permit-type-name result tr lang)]
        [:div.mt-1.text-xs (tr [state])]])]))

(defn complaint-map-result-content [{:keys [result tr lang format-date show-severity?]}]
  (let [{:complaint/keys [category-names severity]
         :domain/keys    [state]
         :keys           [created]}                result
        address                                    (result-address result)
        municipality-name                          (i18n-model/get-text-from-entities-or-map (:municipality/names result) lang)
        category-name                              (i18n-model/get-text-from-entities-or-map category-names lang)
        permit-type-name                           (permit-type-name result tr lang)]
    [:div.flex-grow.overflow-y-auto.pb-2
     [:h3.font-bold.text-lg.mb-2
      (or address (tr [:address/unknown-address]))
      (when municipality-name
        (str ", " municipality-name))]
     (when permit-type-name
       [:div.uppercase.text-xs.font-bold.mb-3 permit-type-name])
     [:div.flex.flex-col.flex-1.gap-3.justify-start
      [public-records-ui/form-row (tr [:public-records/category]) category-name]
      [public-records-ui/form-row (tr [:public-records/created]) (format-date created)]
      [public-records-ui/form-row (tr [:complaint/state]) (tr [state])]
      (when (and show-severity? severity)
        [public-records-ui/form-row (tr [:complaint/severity]) (tr [severity])])]]))

(defn loaded-complaint? [complaint-id loaded-id complaint-loaded? complaint]
  (and (= complaint-id loaded-id)
       complaint-loaded?
       complaint))

(defn loading-complaint? [result loaded-id action-context-loading?]
  (or (:loading? result)
      (and (= (:complaint/id result) loaded-id)
           action-context-loading?)))

(defn actionable-complaint-map-result-content [{:keys [result lang] :as opts}]
  (let [complaint-id              (:complaint/id result)
        loaded-id                 (<sub [::complaint-search-subs/complaint-id])
        complaint-loaded?         (<sub [::complaint-search-subs/complaint-loaded?])
        action-context-available? (<sub [::complaint-search-subs/action-context-available?])
        action-context-loading?   (<sub [::complaint-search-subs/action-context-loading?])
        complaint                 (<sub [::entities/entity {:complaint/id complaint-id}])
        action-events             (complaint-search-subs/map-action-events complaint-id)]
    (cond
      (loaded-complaint? complaint-id loaded-id complaint-loaded? complaint)
      [complaint-dashboard/complaint-view-content {:complaint         complaint
                                                   :lang              lang
                                                   :loading?          false
                                                   :action-events     action-events
                                                   :allow-actions?    action-context-available?
                                                   :case-workspace-id (:complaint/case-workspace-id result)
                                                   :detail-class-name "pb-2"}]

      (loading-complaint? result loaded-id action-context-loading?)
      [:div.flex.flex-1.items-center.justify-center
       (cc/loading-spinner)]

      :else
      [complaint-map-result-content opts])))


(defn complaint-grid-card
  [{:complaint/keys [case-workspace-id severity]
    :domain/keys    [state]
    :keys           [created modified permit-type]
    :as             result}
   {:keys [tr lang show-severity?]}]
  (let [category-name     (i18n-model/get-text-from-entities-or-map (:complaint/category-names result) lang)
        municipality-name (i18n-model/get-text-from-entities-or-map (:municipality/names result) lang)
        permit-type-label (permit-type-name result tr lang)
        go-to-case-tr     (if permit-type
                            (<sub [::complaint-subs/complaint-tr permit-type])
                            tr)]
    ;; A flex column would shrink the tile instead of filling the grid cell.
    [:div {:class   "bx--col-xs-12 bx--col-sm-12 bx--col-md-6 bx--col-xl-4 bx--col-xxl-3 mt-4"
           :data-cy "single-result"}
     (cc/tile
       {:class-name "search-result-box"}
       [:div.content-wrapper.flex.flex-col
        [:div.text-base category-name]
        (when permit-type-label
          [:div.mt-1 permit-type-label])
        [:div.mt-2 (or (result-address result) (tr [:address/unknown-address]))]
        (when municipality-name
          [:div.mt-1 municipality-name])
        [:div.smaller.mt-2
         [ui-updated/updated {:ts          created
                              :verb-tr-key :update-time-v2/created}]]
        (when (and modified (not= created modified))
          [:div.smaller
           [ui-updated/updated {:ts          modified
                                :verb-tr-key :update-time-v2/updated}]])
        (when (and show-severity? severity)
          [:div.smaller.mt-2
           {:data-cy "complaint-severity"}
           [:span (str (tr [:complaint/severity]) ": ")]
           [:span (tr [severity])]])
        [:div.flex.flex-row.items-center.gap-1.state-wrapper.mt-12.pr-2
         [:span {:data-cy "complaint-state"
                 :class   "bold uppercase flex-1"}
          (tr [state])]]]
       [:div.flex.flex-row
        (when case-workspace-id
          [complaint-dashboard/go-to-case-button case-workspace-id go-to-case-tr
           {:data-cy    "go-to-case"
            :class-name "flex-1 mr-2 h-9 max-w-none justify-center rounded-none"}])
        ;; Carbon limits button width; override it so actions fill the card.
        [cc/button {:data-cy    "view-complaint"
                    :size       :small
                    :on-click   #(>evt [::complaint-search-subs/show-complaint-modal
                                        (:complaint/id result)])
                    :class-name (if case-workspace-id
                                  "flex-1 h-9 max-w-none justify-center rounded-none"
                                  "w-full h-9 max-w-none justify-center rounded-none")}
         (tr [:complaint/view-complaint])]])]))

(defn render-search-result [result {:keys [map-search?]}]
  (if map-search?
    [:div.search-result-box
     [:div.content-wrapper.flex.flex-col
      [actionable-complaint-map-result-content
       {:result         result
        :tr             (<sub [:tr])
        :lang           (<sub [:language])
        :format-date    (<sub [::date-util/date-fn])
        :show-severity? (ff/enabled? :feature-flag.id/complaints-priority)}]]]
    [complaint-grid-card result
     {:tr             (<sub [:tr])
      :lang           (<sub [:language])
      :show-severity? (ff/enabled? :feature-flag.id/complaints-priority)}]))

(defn point-group-select [{:keys [group groups]} tr]
  (when (du/at-least-two? groups)
    [:div.px-2.pb-3
     [complaint-dashboard/municipality-select
      {:id             "search-complaint-map-muni-selection"
       :tr             tr
       :lang           (<sub [:language])
       :groups         groups
       :selected-group group
       :on-change      #(>evt [::complaint-search-subs/select-point-group %])}]]))

(defn- map-point-message [point tr on-close content]
  [map-common-info-box/right-side-box {:tr tr :on-cancel-click on-close}
   [point-group-select point tr]
   [:div.flex-grow.px-2.pb-2 content]])

(defn found-map-point-view
  [{point-id :id :keys [coordinates group property complaints] :as point} on-close]
  (let [tr           (<sub [::complaint-subs/property-tr])
        lang         (<sub [:language])
        complaint-id (:complaint/id (<sub [::complaint-subs/complaint-in-view]))
        props        {:tr                tr
                      :lang              lang
                      :selected-group    group
                      :selected-property property
                      :on-close          on-close
                      :header            [point-group-select point tr]}]
    (cond
      (<sub [::complaint-form/create-form-open?])
      [complaint-dashboard/new-complaint-form
       (assoc props
              :coordinates    coordinates
              :on-success-evt ::complaint-search-subs/point-complaint-created)]

      complaint-id
      [map-common-info-box/right-side-box {:tr              tr
                                           :on-cancel-click on-close
                                           :on-back-click   #(>evt [::complaint-subs/close-complaint-view])}
       [complaint-dashboard/complaint-view-content
        {:complaint         (<sub [::entities/entity {:complaint/id complaint-id}])
         :lang              lang
         :loading?          (<sub [::complaint-subs/complaint-view-loading?])
         :selected-property property
         :action-events     (complaint-search-subs/point-action-events point-id)}]]

      :else
      [complaint-dashboard/selected-property-view
       (assoc props
              :complaints         complaints
              :case-cleanup-event [::complaint-search-subs/point-case-cleanup point-id])])))

(defn map-point-view [{:keys [id]} tr]
  (let [{:keys [status] :as point} (<sub [::complaint-search-subs/point])
        on-close                   #(>evt [::complaint-search-subs/close-map-point])]
    (when (= id (:id point))
      (case status
        :found     [found-map-point-view point on-close]
        :not-found [map-point-message point tr on-close (tr [:error/gis-result-not-found])]
        [map-point-message point tr on-close
         [:div.flex.h-full.items-center.justify-center
          (cc/loading-spinner {:with-overlay false})]]))))

(defn overlays [tr lang]
  (let [complaint-id  (<sub [::complaint-search-subs/complaint-id])
        action-events (complaint-search-subs/modal-action-events complaint-id)]
    [:<>
     [complaint-detail-view/complaint-modal-view
      {:allow-edit?   (<sub [::complaint-search-subs/action-context-available?])
       :action-events action-events
       :tr            tr
       :lang          lang}]
     [new-case-view/create-case-modal]
     (when (<sub [::new-case-view/optional-params-modal-open?])
       [new-case-view/optional-params-modal])]))

(defn- list-view-cols [{:keys [tr lang sort-options]}]
  [[:search-filter-attribute/complaint-category-names
    #(i18n-model/get-text-from-entities-or-map (:complaint/category-names %) lang)
    {:truncate? true}]
   [:search-filter-attribute/domain-state (comp tr vector :domain/state) {}]
   [:search-filter-attribute/group-id
    #(i18n-model/get-text-from-entities-or-map (:municipality/names %) lang)
    {}]
   [:updated
    (fn [{:keys [modified modified-by]}]
      [ui-updated/updated {:ts modified :user modified-by}])
    (list-view/sortable-col sort-options :modified)]])

(def search-mode
  {:name                        :complaint
   :search-command              :complaint/find-for-record-search
   :search-config-command       :user/complaint-search-config
   :save-filter-command         :user/upsert-complaint-filter
   :remove-filter-command       :user/remove-complaint-filter
   :map-search-command          :complaint/find-for-record-search-map
   ;; Complaints have no detail page to link to; their list rows open the complaint modal.
   :list-view-cols              list-view-cols
   :list-view-row-click         #(>evt [::complaint-search-subs/show-complaint-modal (:complaint/id %)])
   :title                       :code-enforcement/complaints
   :subtitle                    :code-enforcement/complaint-filters-title
   :filter-subtype              :filter.subtype/complaint
   :filter-condition-attributes complaint-model/record-search-filter-condition-attributes
   :filter-value                (fn [_attr value] value)
   :val->str-fn                 (fn [_search-config tr attribute]
                                  (case attribute
                                    :complaint/category-names identity
                                    (comp tr vector)))
   :id-fn                       :complaint/id
   :render-search-result        render-search-result
   :map-result-open-event       ::complaint-search-subs/load-map-complaint
   :map-result-dismiss-event    ::complaint-search-subs/clear-action-context
   :map-point-click-event       ::complaint-search-subs/select-map-point
   :map-point-dismiss-event     ::complaint-search-subs/map-point-dismissed
   :render-map-point-view       map-point-view
   :cluster-fn                  cluster-results
   :render-clustered-results    render-clustered-results
   :render-overlays             overlays
   :cleanup-event               [::complaint-search-subs/cleanup]
   :default-view                :dashboard-search/list-view})
